module.exports = __webpack_public_path__ + "img/dental3_7-8-2021.9c9d5ec6.jpg";